import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/_Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* <li className="menu-title">{props.t("Menu")} </li> */}
            <li>
              <Link to="/dashboard">
                <i className="bx bxs-dashboard"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-question-mark"></i>
                <span>{props.t("Aspirations")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/aspirations/question/list"><i className="bx bx-radio-circle"></i>{props.t("Aspiration Questions")}</Link>
                  <Link className="d-none" to="/aspirations/question/text/list"></Link>
                </li>
                <li>
                  <Link to="/aspirations/horizontal/list"><i className="bx bx-radio-circle"></i>{props.t("Schor Horizontals")}</Link>
                  <Link className="d-none" to="/aspirations/horizontal/text/list"></Link>
                </li>
                <li>
                  <Link to="/aspirations/vertical/list"><i className="bx bx-radio-circle"></i>{props.t("Schor Verticals")}</Link>
                  <Link className="d-none" to="/aspirations/vertical/text/list"></Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/questionnaire/list">
                <i className="bx bx-list-check"></i>
                <span>{props.t("Questionnaire")}</span>
              </Link>
              <Link className="d-none" to="/questionnaire/text/list"></Link>
            </li>

            {/* <li> */}
              {/* <Link to="/#" className="link-remove">
                <i className="bx bx-paper-plane"></i>
                <span>{props.t("Invitations")}</span>
              </Link> */}
              {/* <ul className="sub-menu">
                <li>
                  <Link to="/invitations/participants/list"><i className="bx bx-radio-circle"></i>{props.t("Participants")}</Link>
                  <Link className="d-none" to="/invitations/participants/text/list"></Link>
                </li>
                <li>
                  <Link to="/invitations/raters/list"><i className="bx bx-radio-circle"></i>{props.t("Raters")}</Link>
                  <Link className="d-none" to="/invitations/raters/text/list"></Link>
                </li>
              </ul> */}
            {/* </li> */}

            <li>
              <Link to="/invitations/participants/list"><i className="bx bx-paper-plane"></i><span>{props.t("Participants Invitation")}</span></Link>
              <Link className="d-none" to="/invitations/participants/text/list"></Link>
            </li>
            <li>
              <Link to="/invitations/raters/list"><i className="bx bx-send"></i><span>{props.t("Raters Invitation")}</span></Link>
              <Link className="d-none" to="/invitations/raters/text/list"></Link>
            </li>

            {/* <li> */}
              {/* <Link to="/#" className="link-remove">
                <i className="bx bx-alarm"></i>
                <span>{props.t("Reminders")}</span>
              </Link> */}
              {/* <ul className="sub-menu">
                <li>
                  <Link to="/reminders/participants/list"><i className="bx bx-radio-circle"></i>{props.t("Participants")}</Link>
                  <Link className="d-none" to="/reminders/participants/text/list"></Link>
                </li>
              </ul> */}
            {/* </li> */}

            <li>
              <Link to="/reminders/participants/list"><i className="bx bx-alarm"></i><span>{props.t("Participants Reminder")}</span></Link>
              <Link className="d-none" to="/reminders/participants/text/list"></Link>
            </li>

            <li>
              <Link to="/batches/list">
                <i className="bx bx-group"></i>
                <span>{props.t("Batches")}</span>
              </Link>

              <Link className="d-none" to="/batches/track/list"></Link>
              <Link className="d-none" to="/participants/list"></Link>
              <Link className="d-none" to="/participants/track/list"></Link>

            </li>

            <li>
              <Link to="/batch/email/list">
                <i className="bx bx-envelope"></i>
                <span>{props.t("Email")}</span>
              </Link>
            </li>

            {/* <li>
              <Link to="/#" className="link-remove">
                <i className="bx bxs-brightness"></i>
                <span>{props.t("Configuration")}</span>
              </Link>
            </li> */}

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-text"></i><span>{props.t("Survey Text")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/configurations/survey/welcome/list"><i className="bx bx-radio-circle"></i>{props.t("Welcome")}</Link>
                </li>
                <li>
                  <Link to="/configurations/survey/middle/list"><i className="bx bx-radio-circle"></i>{props.t("Middle")}</Link>
                </li>
                <li>
                  <Link to="/configurations/survey/thankyou/list"><i className="bx bx-radio-circle"></i>{props.t("Thank You")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/configurations/language/list"><i className="bx bx-flag"></i><span>{props.t("Language")}</span></Link>
            </li>
            <li>
              <Link to="/configurations/raters-type/list"><i className="bx bxs-bookmark-star"></i><span>{props.t("Rater Types")}</span></Link>
              <Link className="d-none" to="/configurations/raters-type/text/list"></Link>

            </li>
            <li>
              <Link to="/configurations/chartcolor/list"><i className="bx bx-palette"></i><span>{props.t("Chart Colors")}</span></Link>
            </li>

            <li>
              <Link to="/" className="has-arrow ">
                <i className="bx bx-globe"></i>
                <span>{props.t("Norms")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/norms/global/list"><i className="bx bx-radio-circle"></i>{props.t("Global Norms")}</Link>
                </li>
                <li>
                  <Link to="/norms/group/list"><i className="bx bx-radio-circle"></i>{props.t("Group Norms")}</Link>
                  <Link className="d-none" to="/norms/group/questionnaire/list"></Link>

                </li>
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
